import { Document, DocumentType } from "thunk-core";

export const getTargetId = (document: Document) => {
  return document.type === DocumentType.NOTE ? document.dateId! : document.id;
};
